import React from 'react';
import TrainImage from '../../../images/features/hida/access-train.png';
import BusImage from '../../../images/features/hida/access-bus.png';
import CarImage from '../../../images/features/hida/access-car.png';
import PlaneImage from '../../../images/features/hida/access-plane.png';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const TYPES = {
  train: [TrainImage, '鉄道利用の場合'],
  bus: [BusImage, 'バス利用の場合'],
  car: [CarImage, '車利用の場合'],
  plane: [PlaneImage, '飛行機利用の場合'],
};

const AccessTitle = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: 'auto',
    height: theme.typography.pxToRem(18),
    [theme.breakpoints.up('sm')]: {
      height: theme.typography.pxToRem(24),
    },
  },
  text: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  },
}))(({ classes, type }) => {
  const [image, text] = TYPES[type];
  return (
    <div className={classes.root}>
      <img src={image} className={classes.icon} />
      <Typography className={classes.text} color="textPrimary">
        {text}
      </Typography>
    </div>
  );
});

export default AccessTitle;
